// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgressBar_wrapper__C2WdW","progressBar":"ProgressBar_progressBar__oHQ4J","loading":"ProgressBar_loading__k25ka","percentLeft":"ProgressBar_percentLeft__RQ01A"};